import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxCircleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 19.4 19.5",
	style: { enableBackground: "new 0 0 19.4 19.5" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.checkbox-circle-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "checkbox-circle-icon-st0",
		d: "M9.7,0C7.8,0,5.9,0.6,4.3,1.6S1.4,4.2,0.7,6s-0.9,3.7-0.6,5.6c0.4,1.9,1.3,3.6,2.7,5s3.1,2.3,5,2.7 c1.9,0.4,3.9,0.2,5.6-0.6c1.8-0.7,3.3-2,4.4-3.6s1.6-3.5,1.6-5.4c0-2.6-1-5.1-2.9-6.9C14.8,1,12.3,0,9.7,0z M14.3,8l-5.5,5.2 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.2l-2.7-2.6C5,10.4,5,10.4,4.9,10.3c0-0.1-0.1-0.2-0.1-0.3 s0-0.2,0-0.3S4.9,9.5,5,9.4s0.2-0.1,0.2-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1C5.9,9.2,6,9.3,6,9.4l2.2,2.1l5-4.8 c0.3,0.1,0.4,0,0.6,0s0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5S14.5,7.9,14.3,8z"
	}) }) }) })]
});
export default SvgCheckboxCircleIcon;
